export enum ZIndex {
	Main = 0,
	LayoutViewport = 1,
	LayoutPanel = 2,
	Overlay = 3,
	ColorPicker = 4,
	Modal = 5,
	MobilePanel = 6,
	Dropdown = 7,
	DragingElement = 1000,
	DeveloperWidgetViewer = 10000,
	DeveloperPanel = 10001,
}
